import axios from 'shared/lib/axios'
import { flashErrorMessage } from 'redux-flash'

import { fetchRetailer } from 'actions/retailerActions'
import { easternToday, toCalendarDate } from 'shared/lib/helpers'
import { FETCH_USERS_DETAILS } from 'shared/UserDropdown/actions'
import { downloadFile } from 'shared/utils'

export const ORDER_FETCH = 'ORDER_FETCH'
export const ORDER_RESPONSE = 'ORDER_RESPONSE'
export const ORDER_FAILURE = 'ORDER_FAILURE'
export const DASHBOARD_FETCH = 'DASHBOARD_FETCH'
export const DASHBOARD_RESPONSE = 'DASHBOARD_RESPONSE'
export const DASHBOARD_FAILURE = 'DASHBOARD_FAILURE'
export const DASHBOARD_PARTNER_RESPONSE = 'DASHBOARD_PARTNER_RESPONSE'
export const UPDATE_SEARCH_STRING = 'UPDATE_SEARCH_STRING'
export const UPDATE_ORDER_SOURCE = 'UPDATE_ORDER_SOURCE'
export const UPDATE_DATE_RANGE = 'UPDATE_DATE_RANGE'
export const SET_D2C_IS_INSTALLED = 'SET_D2C_IS_INSTALLED'

export function setOrderSource(source) {
  return { type: UPDATE_ORDER_SOURCE, source }
}

export function setDateRange(activeStartDate, activeEndDate, activePeriod) {
  return {
    type: UPDATE_DATE_RANGE,
    activeStartDate,
    activeEndDate,
    activePeriod,
  }
}

export const setPeriod = (period) => {
  const today = easternToday()
  return setDateRange(today.clone().subtract(period), today, period)
}

export const setSearchString = (searchString) => ({
  type: UPDATE_SEARCH_STRING,
  searchString,
})

let lastRequestId = 0
const nextRequestId = () => {
  lastRequestId += 1
  return lastRequestId
}

const rangeParams = ({ activeStartDate, activeEndDate }) => ({
  start_date: toCalendarDate(activeStartDate),
  end_date: toCalendarDate(activeEndDate),
})

export const fetchOrders = (page) => (dispatch, getState) => {
  const { activeStartDate, activeEndDate, limit, searchString, source } =
    getState().dashboard
  const requestId = nextRequestId()

  dispatch({ type: ORDER_FETCH, requestId })
  return axios
    .get('/api/order', {
      params: {
        offset: (page - 1) * limit,
        limit,
        source,
        ...(searchString
          ? { search_string: searchString }
          : rangeParams({ activeStartDate, activeEndDate })),
      },
    })
    .then(
      ({ data }) =>
        dispatch({
          type: ORDER_RESPONSE,
          requestId,
          orders: data.orders,
          total: data.total,
        }),
      () => dispatch({ type: ORDER_FAILURE, requestId })
    )
}

export const fetchStatistics = () => (dispatch, getState) => {
  const { activeAggregation, activeStartDate, activeEndDate, source } =
    getState().dashboard
  const requestId = nextRequestId()

  dispatch({ type: DASHBOARD_FETCH, requestId })
  return axios
    .get('/api/warranty_over_time', {
      params: {
        ...rangeParams({ activeStartDate, activeEndDate }),
        group_by: activeAggregation,
        source,
      },
    })
    .then(
      ({ data }) =>
        dispatch({ type: DASHBOARD_RESPONSE, requestId, statistics: data }),
      () => dispatch({ type: DASHBOARD_FAILURE, requestId })
    )
}

export function dashboardPartnerResponse(json) {
  return { type: DASHBOARD_PARTNER_RESPONSE, partner: json.data }
}

export function dashboardPartnerFetch() {
  return (dispatch) => {
    axios
      .get('/api/dashboard/partner')
      .then((json) => dispatch(dashboardPartnerResponse(json)))
      .then(() => dispatch(fetchRetailer()))
  }
}

export const exportWarranties = () => (dispatch, getState) => {
  const { activeStartDate, activeEndDate, source } = getState().dashboard

  return axios
    .get('/api/warranty-export', {
      responseType: 'blob',
      params: { ...rangeParams({ activeStartDate, activeEndDate }), source },
    })
    .then(({ data }) =>
      downloadFile(
        data,
        `mulberry_transaction_report_${toCalendarDate(
          activeStartDate
        )}_to_${toCalendarDate(activeEndDate)}.csv`
      )
    )
    .catch(() =>
      dispatch(
        flashErrorMessage('The export could not be downloaded. Try again.')
      )
    )
}

export const setUserDetails = (user) => ({
  type: FETCH_USERS_DETAILS,
  payload: user,
})

export function setD2CIsInstalled(value) {
  return (dispatch) => {
    dispatch({ type: SET_D2C_IS_INSTALLED, value })
  }
}
